import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export type Provider = 'ALL' | 'SPAY' | 'MTN' | 'ORANGE';
export type OperationType = 'DEPOSIT' | 'WITHDRAW' | 'TRANSFER' | 'MERCHANT_PAY' | 'BILL_PAY';
export type Category = 'STANDARD' | 'GAMBLING';
export type RoundingMode = 'CEIL' | 'FLOOR' | 'HALF_UP';

export interface TaxRule {
  id: number;
  countryCode: string;
  provider: Provider;
  operationType: OperationType;
  category: Category;
  rateBps: number;
  fixedAmount: number;
  currency: 'XAF';
  minAmount?: number;
  maxAmount?: number;
  roundingMode: RoundingMode;
  effectiveFrom: string;
  effectiveTo?: string;
  active: boolean;
  isActive?: boolean; // some APIs may return isActive instead of active
  priority: number;
  createdBy: string;
}

export interface TaxSimulateDTO {
  countryCode: string;
  provider: Provider;
  operationType: OperationType;
  category: Category;
  amount: number;
  currency: 'XAF';
}

@Injectable({ providedIn: 'root' })
export class TaxRuleService {
  private host = environment.apiUrl;

  constructor(private http: HttpClient) { }

  list() {
    return this.http.get<TaxRule[]>(`${this.host}/administration/tax-rules`);
  }

  create(payload: any) {
    return this.http.post<TaxRule>(`${this.host}/administration/tax-rules`, payload);
  }

  update(id: number, payload: any) {
    return this.http.put<TaxRule>(`${this.host}/administration/tax-rules/${id}`, payload);
  }

  deactivate(id: number, note?: string) {
    let params = new HttpParams();
    if (note) params = params.set('note', note);
    return this.http.post(`${this.host}/administration/tax-rules/${id}/deactivate`, null, { params });
  }

  simulate(payload: TaxSimulateDTO) {
    return this.http.post<any>(`${this.host}/administration/tax-rules/simulate`, payload);
  }
}
